import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4 whitespace-nowrap">
            <i className="ri-play-circle-line"></i>
            精选内容
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门视频精选
          </h2>
          <p className="text-sm text-foreground-500 mt-2">精选热门吃瓜视频图文内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded-md bg-foreground-950/80 text-background-50 text-xs whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/10 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="text-[10px] font-medium text-accent-600 bg-accent-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                  {item.category}
                </span>
                <h3 className="text-sm font-medium text-foreground-800 mt-2 line-clamp-2 leading-snug">{item.title}</h3>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}